export enum SonarObjectType {
	PardotAutomation = 'pardotAutomation',
	PardotEmail = 'pardotEmail',
	PardotEmailTemplate = 'pardotEmailTemplate',
	PardotEntity = 'pardotEntity',
	PardotField = 'pardotField',
	PardotForm = 'pardotForm',
	PardotLandingPage = 'pardotLandingPage',
	PardotList = 'pardotList',
	PardotPageAction = 'pardotPageAction',
	PardotProfile = 'pardotProfile',
	SalesforceApexClass = 'sfdcApexClass',
	SalesforceApexTrigger = 'sfdcApexTrigger',
	SalesforceEmailTemplate = 'sfdcEmailTemplate',
	SalesforceEntity = 'sfdcEntity',
	SalesforceField = 'sfdcField',
	SalesforceFlow = 'sfdcFlow',
	SalesforcePageLayout = 'sfdcPageLayout',
	SalesforcePicklistValue = 'sfdcPicklistValue',
	SalesforceProcessBuilder = 'sfdcProcessBuilder',
	SalesforceProfile = 'sfdcProfile',
	SalesforceReport = 'sfdcReport',
	SalesforceWorkflowRule = 'sfdcWorkflowRule',
	SalesforceWorkflowAlert = 'sfdcWorkflowAlert',
	SalesforceFieldUpdate = 'sfdcFieldUpdate',
	SalesforceValidationRule = 'sfdcValidationRule',
	SonarTag = 'sonarTag'
}

export enum SonarObjectTypeId {
	SonarTag = 0,
	SalesforceEntity = 1,
	SalesforceField = 2,
	SalesforceFlow = 3,
	SalesforcePicklistValue = 4,
	SalesforceProcessBuilder = 5,
	SalesforceWorkflowRule = 6,
	SalesforceValidationRule = 7,
	SalesforceApexClass = 8,
	SalesforceReport = 9,
	SalesforceApexTrigger = 13,
	PardotList = 14,
	PardotProfile = 15,
	PardotForm = 16,
	PardotLandingPage = 17,
	PardotEmailTemplate = 18,
	PardotEntity = 19,
	PardotField = 20,
	SalesforcePageLayout = 21,
	SalesforceProfile = 22,
	SalesforceEmailTemplate = 23,
	PardotAutomation = 24,
	PardotPageAction = 25,
	PardotEmail = 26,
	SalesforceFieldUpdate = 27,
	SalesforceEmailAlert = 28,
}
